<template>
    <div class="d-flex justify-content-center flex-column flex-wrap pt-4 text-center" v-if="isLoading">
        <div>
            <div class="spinner-border" role="status">
                <span class="sr-only">{{ $t('loading') }}...</span>
            </div>
        </div>
        <h4 class="mt-5" v-if="!this.queryResolved && this.longWaitInfo" v-html="this.longWaitInfo" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {trackGA} from '@utilities/tracking';
    import {AIRPORT_TRANSFERS_LONG_WAIT_MESSAGE_TIMEOUT} from '@/constants';
    import i18n from '@/i18n';
    import backofficeRepository from '@repositories/BackofficeRepository';
    import toastr from 'toastr';

    export default {
        data() {
            return {
                isLoading: true,
                queryResolved: false,
                longWaitInfo: null,
            };
        },
        computed: {
            ...mapGetters({
                searchData: 'airportTransfersSearch/getSearchParameters',
            }),
        },
        created() {
            trackGA('checkout_progress', {
                checkout_step: 2,
                checkout_option: window.location.pathname,
            });

            const query = this.$route.query;

            if (parseInt(query.with_return) === 0) {
                delete(query.return_date);
            }

            query.with_return = parseInt(query.with_return);
            query.passengers_number = parseInt(query.passengers_number);

            if (query.start_place) {
                this.$store.dispatch('airportTransfersSearch/setSearchParameters', query).then(() => {
                    this.searchDepartures(query);
                    return;
                });
            } else {
                this.searchDepartures(this.searchData);
            }
        },
        methods: {
            scheduleLongWaitMessage() {
                if(false === AIRPORT_TRANSFERS_LONG_WAIT_MESSAGE_TIMEOUT){
                    return;
                }
                this.queryResolved = false;
                setTimeout(function(){
                    if(!this.queryResolved){
                        this.longWaitInfo = i18n.tc('maintenance_long_wait_info');
                    }
                }.bind(this), AIRPORT_TRANSFERS_LONG_WAIT_MESSAGE_TIMEOUT);
            },

            setQueryResolved() {
                this.queryResolved = true;
                this.longWaitInfo = null;
            },

            async searchDepartures (searchData) {
                this.scheduleLongWaitMessage();
                const nameToSearchDepartures = new RegExp(searchData.start_place + '\\s?-\\s?' + searchData.end_place);
                const nameToSearchReturns = new RegExp(searchData.end_place + '\\s?-\\s?' + searchData.start_place);

                // const searchDepartures = AirportTransferRepository.searchDepartures(searchData);
                const searchBackofficeDepartures = backofficeRepository.findAvailableLinesForClientOrder(searchData.departure_date);
                let searchBackofficeReturns = null;
                if(searchData.with_return){
                    searchBackofficeReturns = backofficeRepository.findAvailableLinesForClientOrder(searchData.return_date);
                }

                //filter searchBackoffice promise with nameToSearch regex
                Promise.all([searchBackofficeDepartures, searchBackofficeReturns])
                    .catch((e) => {
                        this.setQueryResolved();
                        this.$router.push({name: 'airport-transfers.index'});
                        throw e;
                    })
                    //filter correct travels
                    .then((responses) => { return [responses[0].filter((item) => nameToSearchDepartures.test(item.name)), responses[1]?responses[1].filter((item) => nameToSearchReturns.test(item.name)):null]; })
                    .then((responses) => {
                        this.setQueryResolved();
                        const departures = responses[0];
                        const returns = responses[1];
                        //generate random sessionID
                        const sessionID = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                        const currency = window.APP.locale=='pl'?'PLN':'EUR';

                        if(!departures.length){
                            //show error message and redirect back
                            toastr.error(this.$t('taxi.pages.vehicles.no_transfers_found'));
                            this.$router.push({ name: 'airport-transfers.index' });
                            return;
                        }
                        if(searchData.with_return && !returns.length){
                            //show error message and redirect back
                            toastr.error(this.$t('taxi.pages.vehicles.no_transfers_found'));
                            this.$router.push({ name: 'airport-transfers.index' });
                            return;
                        }

                        this.$store.dispatch('airportTransfersSearch/setSessionId', sessionID).then(() => {
                            this.$store.dispatch('airportTransfersSearch/setCurrency', currency).then(() => {
                                if (searchData.with_return) {
                                    return this.$store.dispatch('airportTransfersSearch/setDeparturesResult', departures).then(() => {
                                        return this.$store.dispatch('airportTransfersSearch/setReturnsResult', returns);
                                    });
                                }
                                else{
                                    return this.$store.dispatch('airportTransfersSearch/setDeparturesResult', departures);
                                }
                            });
                        });
                    })
                    .then(() => {
                        this.$store.dispatch('airportTransfersSearch/setIsSearchComplete', true).then(() => {
                            this.$router.replace(({name: 'airport-transfers.departures'}));
                        });
                    });
            },
        },
    };
</script>
